import { render, staticRenderFns } from "./shopping-cart-product-item.vue?vue&type=template&id=495a3dc4&"
import script from "./shopping-cart-product-item.vue?vue&type=script&lang=ts&"
export * from "./shopping-cart-product-item.vue?vue&type=script&lang=ts&"
import style0 from "./shopping-cart-product-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports